import { motion } from 'framer-motion';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BottomMenuButtons, MoreMenuItems } from '@constants/menu';
import useAuth from '@hooks/useAuth';
import { colors } from '@styles/vars';

// styled components
import { Container } from './style';

const BottomMenu = (props) => {
  const [selectedValue, setSelectedValue] = useState('Home');
  const [scrollDir, setScrollDir] = useState('up');
  const [moreOpen, setMoreOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const location = window.location.href;

  const handleChange = (event, newValue) => {
    setSelectedValue(newValue);
  };

  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const direction = scrollY > lastScrollY ? 'down' : 'up';
      if (direction !== scrollDir) {
        setScrollDir(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener('scroll', updateScrollDirection);
    return () => {
      window.removeEventListener('scroll', updateScrollDirection);
    };
  }, [scrollDir]);

  const tabsStyles = {
    width: '100%',
    '& .MuiTabs-indicator': {
      top: 0,
      bottom: 'unset',
      backgroundColor: '#000000', // Change the upper line to black on selected tab
    },
    '& .MuiTabs-flexContainer': {
      justifyContent: 'space-between',
    },
  };

  const tabStyles = {
    minWidth: 0,
    flexGrow: 1,
    '&.Mui-selected': {
      color: '#000000', // Dark black icon color when selected
    },
    '& .MuiTab-iconWrapper': {
      transition: 'transform 0.3s ease', // Smooth transition for tilt effect
    },
    // '&.Mui-selected .MuiTab-iconWrapper': {
    //   transform: 'rotate(-10deg)', // Slight tilt when selected
    // },
  };

  useEffect(() => {
     if(location.includes('home')){
      setSelectedValue('Home');
     }else if(location.includes('patients')){
      setSelectedValue('Patients');
     }else if(location.includes('leads')){
      setSelectedValue('Leads');
     }else if(location.includes('lead-drop')){
      setSelectedValue('More');
     }else if(location.includes('users')){
      setSelectedValue('Users');
     }else if(location.includes('templates')){
      setSelectedValue('Templates');
     }else if(location.includes('clinics')){
      setSelectedValue('Clinics');
     }else if(location.includes('negative-keywords')){
      setSelectedValue('More');
     }else{
      setSelectedValue(false);
     }
  }, [location]);

  const visibleMoreItems = MoreMenuItems.filter((item) =>
    item.role.includes(user.role.toLowerCase())
  );

  const moreRowValue =
    visibleMoreItems.find((item) => location.includes(item.link.replace('/', '')))?.name || false;

  const handleTabClick = (item) => {
    if (item.isMore) {
      setMoreOpen((prev) => !prev);
      return;
    }
    navigate(item.link);
  };

  return (
    <Container
      as={motion.div}
      initial={{ y: '0%' }}
      animate={{ y: scrollDir === 'down' ? '100%' : '0%' }}
      transition={{ duration: 0.3, ease: 'linear', type: 'tween' }}
    >
      {/* The bar itself grows: More items stack above the tab row */}
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <Collapse in={moreOpen} unmountOnExit>
          <Tabs
            value={moreRowValue}
            variant="fullWidth"
            sx={{ ...tabsStyles, borderBottom: `1px solid ${colors.light_gray}` }}
          >
            {visibleMoreItems.map((item, index) => (
              <Tab
                value={item.name}
                key={index}
                onClick={() => {
                  setMoreOpen(false);
                  navigate(item.link);
                }}
                icon={item.name === moreRowValue ? item.selectedIcon : item.icon}
                label={<span style={{ fontSize: '0.75rem' }}>{item.name}</span>}
                sx={tabStyles}
              />
            ))}
          </Tabs>
        </Collapse>

        <Tabs
          value={selectedValue}
          onChange={handleChange}
          variant="fullWidth"
          sx={tabsStyles}
        >
          {BottomMenuButtons
            .filter((menu) => menu.role.includes(user.role.toLowerCase()))
            .filter((menu) => !menu.isMore || visibleMoreItems.length > 0)
            .map((item, index) => (
              <Tab
                value={item.name}
                key={index}
                onClick={() => handleTabClick(item)}
                icon={item.name === selectedValue ? item.selectedIcon : item.icon}
                label={<span style={{ fontSize: '0.75rem' }}>{item.name}</span>}
                sx={tabStyles}
              />
            ))}
        </Tabs>
      </Box>
    </Container>
  );
};

export default BottomMenu;
